import { render } from "./SlackMessageReplyBar.vue?vue&type=template&id=64a650ba"
import script from "./SlackMessageReplyBar.vue?vue&type=script&lang=js"
export * from "./SlackMessageReplyBar.vue?vue&type=script&lang=js"

import "./SlackMessageReplyBar.vue?vue&type=style&index=0&id=64a650ba&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__